import { FaEdit, FaTrash } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { API_CONFIG, API_HEADERS } from "../../network/config/ApiConfig";
import { AUDIO_ROOM_API_PATH, USER_API_PATH } from "../../network/config/apiPaths";
import { updateMessage } from "../../redux/slice/toastSlice";
import { useDispatch } from "react-redux";
import { consoleLog } from "../../utils/log-utils";
// import { axiosApi } from "../../../network/service/config/AaxiosUtil";
import { useState } from "react";
import { isAdmin, isFranchisLogin } from "../../utils/userRoles";
import axios from "axios";

function AlbumRoomsItem(props) {
  const navigate=useNavigate();
  const dispatch=useDispatch();
  const [product, setItem] = useState(props.item);
  const [itemStatus, setitemStatus] = useState(product.status);
  const reviews=()=>{
     navigate("/reviews",{state:{name:product.title,roomId:product.id}})
  }
  const onStatusChange = async () => {
    let statusOfAlbum = 1;
    if (product.status == 0) {
      statusOfAlbum = 1;
    } else {
      statusOfAlbum = 0;
    }

    let requestbody = {
            title:product.title,
            description: product.description,
            max_participants: product.max_participants,
            max_audiance: product.max_audiance,
            // url:product.url,
            // duration:product.date,
            status:statusOfAlbum,
            id:product.id

            //  title: inputValidation.name,
            // description: inputValidation.description,
            // max_participants: inputValidation.max_participants,
            // max_audiance: inputValidation.max_audiance,
            // url:inputValidation.url,
            // duration:inputValidation.date
        }
        let data = await axios.post(API_CONFIG.API_HOST + AUDIO_ROOM_API_PATH.AUDIO_ROOM_UPDATE,requestbody, {
            headers: API_HEADERS
        })
        console.log("result",data.status,data.statusCode);
       if (data.status == 200) {
        console.log("..................................,",statusOfAlbum)
          setItem(product, (product.status = statusOfAlbum));
          setitemStatus(statusOfAlbum);
        }

  //   let requestBody = {
  //     status: status,
  //     id: product.id,
  //   };

  //   await axiosApi
  //     .post(API_CONFIG.API_HOST + USER_API_PATH.UPDATE_USER, requestBody, {
  //       API_HEADERS,
  //     })
  //     .then((response) => {
  //       consoleLog("USER UPODATE", response);
  //       if (response.status === 200 && response.data.status === true) {
  //         setItem(product, (product.status = status));
  //         setitemStatus(status);
  //       } else {
  //         dispatch(
  //           updateMessage({
  //             display: true,
  //             message: "Error While updating info",
  //           })
  //         );
  //       }
  //     });

  //   // await dispatch(createUpdateAction(requestBody)).then((response) => {
  //   //   if (response.status == true) {
  //   //     setItem(product, (product.status = status));
  //   //     setitemStatus(status);
  //   //   } else {
  //   //     dispatch(
  //   //       updateMessage({
  //   //         display: true,
  //   //         message: "Error While updating info",
  //   //       })
  //   //     );
  //   //   }
  //   // });
   };
 const addAlbumParticipents=()=>{
  navigate("/addAlbumParticipents",{state:{roomId:product.id}})
 }
  return (
    <>
      <tr>
        <td> {props.sno} </td>
        <td>{product.created_at.substring(0,10)}</td>
        <td onClick={reviews}>
          <Link className="anchor-color-change">{product.title}</Link>
        </td>       
        {/* <td> {props.city} </td> */}
        {/* {product.patners} {product.patners.length>0?<br/>:""}<button className="btn btn-success" onClick={addAlbumParticipents}>Add</button> */}
        <td><button className="btn btn-purple-bg" onClick={addAlbumParticipents}>Add</button></td>
        <td onClick={reviews}><Link>4</Link></td>
       

        <td className="align-middle">
          <div class="form-check form-switch col-lg-12 d-flex justify-content-center">

            <input
              class="form-check-input"
              type="checkbox"
              role="switch"
              onChange={onStatusChange}
              checked={itemStatus == 1 ? true : false}

            />

          </div>
        </td>
      </tr>
    </>
  );
}

export default AlbumRoomsItem;
